import { Box, Card, CardContent, Grid, Skeleton } from '@mui/material';
import { Container } from '../../../components/container';

export const ClustersSkeleton = () => (
  <Container>
    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
      <Skeleton variant="text" width={150} height={40} />
      <Skeleton variant="rectangular" width={120} height={40} sx={{ borderRadius: 1 }} />
    </Box>

    <Box sx={{ mb: 3 }}>
      <Skeleton variant="rectangular" width="100%" height={100} sx={{ borderRadius: 2 }} />
    </Box>

    <Grid container spacing={3}>
      {[...Array(6)].map((_, index) => (
        <Grid size={{ xs: 12, md: 6, lg: 4 }} key={index}>
          <Card sx={{ height: '100%' }}>
            <CardContent sx={{ p: 3 }}>
              <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                <Skeleton variant="circular" width={48} height={48} sx={{ mr: 2 }} />
                <Box sx={{ flex: 1 }}>
                  <Skeleton variant="text" width="60%" sx={{ fontSize: '1.25rem' }} />
                  <Skeleton variant="text" width="40%" sx={{ fontSize: '0.875rem' }} />
                </Box>
              </Box>
              <Skeleton variant="text" width="100%" />
              <Skeleton variant="text" width="80%" />
              <Skeleton variant="rectangular" width="100%" height={32} sx={{ mt: 2, borderRadius: 1 }} />
            </CardContent>
          </Card>
        </Grid>
      ))}
    </Grid>
  </Container>
);
